(() => {
  if (window.dtConsentBridge) return;
  window.dtConsentBridge = true;
  let previous = '';
  function update() {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy?.currentVisitorConsent || !window.gtag) return;
    const choice = privacy.currentVisitorConsent();
    if (!choice || !['yes', 'no'].includes(choice.analytics) && !['yes', 'no'].includes(choice.marketing)) return;
    const analytics = choice.analytics === 'yes' && privacy.analyticsProcessingAllowed() === true;
    const marketing = choice.marketing === 'yes' && privacy.marketingAllowed() === true;
    const state = {
      analytics_storage: analytics ? 'granted' : 'denied',
      ad_storage: marketing ? 'granted' : 'denied',
      ad_user_data: marketing ? 'granted' : 'denied',
      ad_personalization: marketing ? 'granted' : 'denied'
    };
    const key = JSON.stringify(state);
    if (key === previous) return;
    previous = key;
    window.gtag('consent', 'update', state);
  }
  document.addEventListener('visitorConsentCollected', update);
  function connect() {
    if (window.Shopify?.customerPrivacy) { update(); return; }
    if (typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
        if (!error) update();
      });
    }
  }
  connect();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, { once: true });
  else window.addEventListener('load', connect, { once: true });
})();
